<div class="mybets-scoreboard_info font-small">
    @switch (showEventDate) {
        @case (true) {
            @if (vm.liveAlert.liveAlert) {
                <ms-alert class="alert-scoreboard" tracking="scoreboard" [disable]="true" [model]="vm.liveAlert"></ms-alert>
            }
            <span class="mybets-scoreboard_info-event_date"
                >{{ vm.startTime | date: 'shortDate' }}
                <ng-container *msShowInEpcot="true"> • </ng-container>
                <ng-container *msShowInEpcot="false"> </ng-container>
                {{ vm.startTime | date: 'shortTime' }}</span
            >
        }
        @case (false) {
            @if (vm.isLive && !hideLiveBadge) {
                <span class="mybets-scoreboard_info-live-badge">{{ liveText }}</span>
            }

            @if (vm.hasStreams) {
                <span class="mybets-scoreboard_info-video-badge sports-video-badge-b"></span>
            }

            @if (vm.sportId === 6 && vm.isLive) {
                <div class="laps-weather-info">
                    @if (vm.lapCounter && vm.lapCounter!.visible) {
                        <span class="laps">
                            {{ sitecoreEventDetails.eventDetails['Laps'] }} {{ vm.lapCounter!.current }}/{{ vm.lapCounter!.final }}</span
                        >
                    }

                    <span class="lap-weather-divider"></span>
                    @if (vm.weather !== null) {
                        <span class="weather">
                            <vn-icon size="12" name="sports-sb-weather-{{ vm.weather }}-i" />
                        </span>
                    }
                </div>
            }

            @if (vm.liveAlert.liveAlert) {
                <ms-alert class="alert-scoreboard" tracking="scoreboard" [disable]="true" [model]="vm.liveAlert"></ms-alert>
            }

            @if (showPeriodInfo) {
                <span class="mybets-scoreboard_info-period-info">{{ periodInfo }}</span>
            }

            @if (vm.timer && vm.timer!.shouldBeVisible() && showTimer()) {
                <ms-my-bets-scoreboard-timer [vm]="vm.timer"></ms-my-bets-scoreboard-timer>
            }
        }
    }
</div>
